export default __webpack_public_path__ + "static/media/job_vacancies_anonime.61fe40c5.less";